module.exports = __webpack_public_path__ + "static/WMW_Wordmark-f8f6ef509a2b0ca3615f879f4462845d.svg";